module.exports = __webpack_public_path__ + "static/media/hidratacion50k.0a9613b1.webp";